module.exports = __webpack_public_path__ + "img/page_top_cover@2x.eb2b55d3.png";